import React from "react";
import { MSection } from "components/misc";
import { Row, Col } from "design-react-kit";
import { Helmet } from "react-helmet";
import { pageService, payloadBuilder } from "libs";

import {
  ValidatedForm,
  MInput,
  MSelect,
  MCheckbox,
} from "components/forms";

export class FormTfaSostegnoTriennalistiView extends ValidatedForm {
  constructor(props) {
    super(props);
    this.state = {
      ...this.emptyFields,
      defaultValues: { ...this.emptyFields },
      formActive: true,
      regions: [],
      isChecked: false,
      isSuccess: 0,
    };
  }

  PAYLOADS_SCHOOLTYPES = {
    options: [
      { value: "", label: "Selezionare" },
      { value: "Infanzia", label: "scuola dell'infanzia" },
      { value: "Primaria", label: "scuola primaria" },
      { value: "Secondaria di primo grado", label: "scuola secondaria di I grado" },
      { value: "Secondaria di secondo grado", label: "scuola secondaria di II grado" }
    ],
  }

  PAYLOAD_REGION = {
    options: [
      {
        label: "Seleziona Regione",
        value: "",
      },
      {
        label: "Abruzzo",
        value: "Abruzzo",
      },
      {
        label: "Basilicata",
        value: "Basilicata",
      },
      {
        label: "Calabria",
        value: "Calabria",
      },
      {
        label: "Campania",
        value: "Campania",
      },
      {
        label: "Emilia-Romagna",
        value: "Emilia-Romagna",
      },
      {
        label: "Friuli-Venezia Giulia",
        value: "Friuli-Venezia Giulia",
      },
      {
        label: "Lazio",
        value: "Lazio",
      },
      {
        label: "Liguria",
        value: "Liguria",
      },
      {
        label: "Lombardia",
        value: "Lombardia",
      },
      {
        label: "Marche",
        value: "Marche",
      },
      {
        label: "Molise",
        value: "Molise",
      },
      {
        label: "Piemonte",
        value: "Piemonte",
      },
      {
        label: "Puglia",
        value: "Puglia",
      },
      {
        label: "Sardegna",
        value: "Sardegna",
      },
      {
        label: "Sicilia",
        value: "Sicilia",
      },
      {
        label: "Toscana",
        value: "Toscana",
      },
      {
        label: "Trentino-Alto Adige/Südtirol",
        value: "Trentino-Alto Adige/Südtirol",
      },
      {
        label: "Umbria",
        value: "Umbria",
      },
      {
        label: "Valle d'Aosta/Vallée d'Aoste",
        value: "Valle d'Aosta/Vallée d'Aoste",
      },
      {
        label: "Veneto",
        value: "Veneto",
      },
    ],
  };

  emptyFields = {
    name: "",
    surname: "",
    dob: "",
    email: "",
    mobile: "",
    durata: "",
    region: "",
    accept: false,
    type: "tfa_sostegno_triennalisti",
    schoolType: '',
    durata: '',
  };

  FIELDS_GROUP = [
    [
      {
        id: "name",
        field: "name",
        label: "Nome",
        component: MInput,
        type: "text",
        className: "col-md-6",
      },
      {
        id: "surname",
        field: "surname",
        label: "Cognome",
        component: MInput,
        type: "text",
        className: "col-md-6",
      },
    ],
    [
      {
        id: "dob",
        field: "dob",
        label: "Data di nascita",
        component: MInput,
        type: "date",
        className: "col-md-6",
      },
    ],
    [
      {
        id: "email",
        field: "email",
        label: "Email",
        component: MInput,
        type: "email",
        className: "col-md-6",
      },
      {
        id: "mobile",
        field: "mobile",
        label: "Cellulare",
        component: MInput,
        type: "text",
        className: "col-md-6",
      },
    ],
    [
      {
        id: "schoolType",
        field: "schoolType",
        label: "Partecipa per: ",
        payload: { options: this.PAYLOADS_SCHOOLTYPES.options },
        component: MSelect,
        className: "col-md-6",
      },
      {
        id: "durata",
        field: "durata",
        label: "Numero anni di servizio sul sostegno negli ultimi 5 anni cioè dal 01 Settembre 2020 ",
        component: MInput,
        type: "text",
        className: "col-md-6",
      },
    ],
    [
      {
        id: "region",
        field: "region",
        label: "Regione dove svolgerà la prova finale",
        payload: { options: this.PAYLOAD_REGION.options },
        component: MSelect,
        className: "col-md-6",
      },
    ],
    [
      {
        id: "accept",
        field: "accept",
        label:
          "Dichiaro di aver letto la Privacy Policy ai sensi del Regolamento UE 2016/679 (GDPR)",
        component: MCheckbox,
        className: "col-md-12",
      },
    ],
  ];

  ERROR_MESSAGES = {
    name: "Inserisci il tuo nome",
    surname: "Inserisci il tuo cognome",
    email: "Inserisci la tua email",
    dob: "Seleziona la tua data di nascita",
    region: "Seleziona la regione",
    accept: "Accetta la privacy policy per continuare",
    mobile: "Inserisci il tuo numero di telefono",
    schoolType: "Valore obbligatorio",
    durata: "Valore obbligatorio",
  };

  validation = {
    name: (value) => value !== "",
    surname: (value) => value !== "",
    region: (value) => value !== "",
    email: (value) => /\S+@\S+\.\S+/.test(value),
    accept: (value) => value !== false,
    mobile: (value) => value !== "",
    dob: (value) => value !== "",
    durata: (value) => value !== "" && parseInt(value) > 0 && parseInt(value) < 6,
    schoolType: value => value > '',
  };

  saveRemote = () => {
    let payload = payloadBuilder(this.state);

    pageService
      .saveContactRequest(payload)
      .then((result) => {
        this.setState({ isSuccess: 200 });
      })
      .catch((errors) => {
        if (errors.response.status === 422) {
          this.setState({ isSuccess: 422 });
        }
      });
  };

  onCancel = () => {
    this.resetForm();
  };

  render() {
    let { formActive, defaultValues } = this.state;
    const { formValid, code } = this.renderFields(
      this.FIELDS_GROUP,
      defaultValues,
      formActive
    );

    const title =
      "";


    return (
      <>
        <Helmet>
          <title>{title}</title>
          <meta property="og:title" content={title} />
        </Helmet>
        <MSection>
          <Row>
            <Col>
              <div class="text-center">
                <h2>Percorso di Specializzazione Universitaria per le Attività di Sostegno Didattico agli Alunni con Disabilità</h2>
                <p>In attuazione del D.M. n. 75 del 24 aprile 2025 e ss.mm.ii - Art. 6 del D.L. 71/2024</p>
              </div>
              <hr />
              <p>L'Università comunica l'apertura delle iscrizioni ai percorsi universitari di specializzazione per le attività di sostegno didattico, rivolti ai docenti in possesso dei requisiti previsti dal D.M. n. 75 del 24 aprile 2025 e ss.mm.ii - Art. 6 del D.L. 71/2024. Il percorso è finalizzato al conseguimento del titolo universitario di specializzazione per il sostegno, valido su tutto il territorio nazionale.
              </p>
              <hr />
              <h5>Presentazione della domanda</h5>
              <ul>
                <li><a href="https://unicamillus.org/corsi/tfa-di-sostegno/triennalisti/?_gl=1*144kn73*_up*MQ..*_ga*MTkxNjQyMzk4MS4xNzczOTMwNjg4*_ga_XFJMNJBV5Q*czE3NzM5MzA2ODgkbzEkZzAkdDE3NzM5MzA2ODgkajYwJGwwJGgw#panoramica">Scuola Primaria</a></li>
                <li><a href="https://unicamillus.org/corsi/tfa-di-sostegno/triennalisti/?_gl=1*144kn73*_up*MQ..*_ga*MTkxNjQyMzk4MS4xNzczOTMwNjg4*_ga_XFJMNJBV5Q*czE3NzM5MzA2ODgkbzEkZzAkdDE3NzM5MzA2ODgkajYwJGwwJGgw#panoramica">Scuola secondaria di I Grado</a></li>
                <li><a href="https://unicamillus.org/corsi/tfa-di-sostegno/triennalisti/?_gl=1*144kn73*_up*MQ..*_ga*MTkxNjQyMzk4MS4xNzczOTMwNjg4*_ga_XFJMNJBV5Q*czE3NzM5MzA2ODgkbzEkZzAkdDE3NzM5MzA2ODgkajYwJGwwJGgw#panoramica">Scuola secondaria di II Grado</a></li>
              </ul>
              <p><b>SCADENZA ISCRIZIONI: 19 Maggio 2026 ore 15:00</b></p>
              <hr />
              {/* <ul>
                <li><a href="/assets/doc/DR_365_Bando_ammissione_percorsi_specializzazione_40_CFU.pdf" target="_blank">Bando di partecipazione</a></li>
                <li><a href="/assets/doc/Allegato_A_DR_365.pdf" target="_blank">Allegato A</a></li>
                <li><a href="/assets/doc/Guida_iscrizione_dm_75.pdf" target="_blank">Guida all'iscrizione</a></li>
                <li>Iscrizione <a href="https://unicamillus-studenti.gomp.it/" target="_blank">https://unicamillus-studenti.gomp.it/</a> (entro le ore 15 di Mercoledì 16 Luglio)</li>
                <li><a href="/assets/doc/informativa _Privacy_avviso_sostegno.pdf" target="_blank">Privacy</a></li>
              </ul>
              <p><a href="https://www.mim.gov.it/web/guest/faq20" target="_blank">FAQ triennalisti (art. 6 del D.L.n. 71/2024)</a></p>
              <hr />*/}
              <h5>Requisiti di accesso</h5>
              <p>Possono accedere i docenti che, alla data del 31 agosto 2025 siano in possesso del titolo di studio necessario all'insegnamento nello specifico grado scolastico e abbiano maturato almeno tre anni di servizio su posto di sostegno, anche non continuativi, nelle scuole statali o paritarie, negli ultimi otto anni. Il servizio deve essere prestato nel medesimo grado in cui si richiede la partecipazione al corso.
                Per anno scolastico si intende il servizio prestato per almeno180 giorni ovvero prestato continuativamente dal 1° febbraio agli scrutini finali.
                L'iscrizione è consentita solo per il grado di istruzione in cui è stato maturato il servizio.
              </p>
              <hr />
              <h5>Struttura del percorso</h5>
              <p>Il percorso formativo, della durata minima di tre mesi, prevede:</p>
              <ul>
                <li>Acquisizione di 40 CFU (crediti formativi universitari)</li>
                <li>Lezioni sincrone online, con una quota massima del 10% in modalità asincrona</li>
                <li>Laboratori didattici sincroni, specifici per ogni grado scolastico</li>
                <li>Esami intermedi in presenza (valutazione in trentesimi)</li>
                <li>Esame finale in presenza, con discussione di un elaborato su un caso didattico</li>
              </ul>
              <p>Le assenze sono consentite fino a un massimo del 10% del monte ore complessivo. Non è previsto il riconoscimento di crediti pregressi da altri percorsi.
              </p>
              <hr />
              <h5>Costi</h5>
              <p>Contributo pari a € 50,00 per la presentazione della domanda di ammissione.</p>
              <p>Partecipazione € 1.300, suddiviso in quattro rate: </p>
              <ul>
                <li>€156 entro i termini dell'immatricolazione (comprensivo di marca da bollo)</li>
                <li>€334 entro il 31/07/2026</li>
                <li>€380 entro il 31/08/2026</li>
                <li>€380 entro il 30/09/2026</li>
              </ul>
              <hr />
              <h5>Modalità di pagamento</h5>
              <p>con PagoPA o Carta docenti (la Carta può essere utilizzata esclusivamente per il pagamento della seconda, terza e/o quarta rata)</p>
              <hr />
              <h5>Graduatorie e perfezionamento iscrizione</h5>
              <p>Le graduatorie e tutte le informazioni riferite alle procedure di immatricolazione verranno pubblicate
                ai seguenti link <a href="https://unicamillus.org/">www.unicamillus.org</a>  <a href="https://www.formazionedocenti.it/adesioni-tfa-sostegno-triennalisti">https://www.formazionedocenti.it/adesioni-tfa-sostegno-triennalisti</a>
                e avranno valore di notifica ufficiale. In caso di rinuncia, si procederà allo scorrimento.</p>
              <p>L'iscrizione al percorso non è compatibile con altri corsi a frequenza obbligatoria.</p>
              <p>Il titolo universitario di specializzazione verrà rilasciato ai candidati che avranno frequentato almeno il 90% delle attività, superato tutti gli esami previsti e completato i versamenti richiesti.</p>
              <p>Le attività hanno una durata di non meno di 3 mesi. Gli esami finali si svolgeranno in autunno 2026.</p>
              <p>Per eventuali informazioni:</p>
              {/*<p>Indirizzo email: <a href="mailto:sostegnoindire@formazionedocenti.it">sostegnoindire@formazionedocenti.it</a></p>*/}
              <p><b>ATTENZIONE:</b></p>
              <p>A causa dei tempi estremamente ristretti e vista l'elevata richiesta di notizie, tutte le informazioni relative ai suddetti corsi saranno rese disponibili esclusivamente attraverso il presente sito web e tramite la propria area riservata.
              </p>
              <hr />
              <h5>Graduatorie delle procedure concorsuali pregresse</h5>
              <p>Al seguente link potete consultare le graduatorie <a href="https://unicamillus.org/corsi/tfa-di-sostegno/triennalisti/" target="_blank" rel="noopener noreferrer">https://unicamillus.org/corsi/tfa-di-sostegno/triennalisti/</a></p>
              <h5>CALENDARIO DELLE ATTIVITÀ DIDATTICHE</h5>
              <p>Il calendario delle attività didattiche è disponibile nell’area riservata degli ammessi.</p>
            </Col>
          </Row>
        </MSection >
      </>
    );
  }
}